import TinderCard from 'react-tinder-card'
import {useCallback, useEffect, useState} from 'react'
import ChatContainer from '../components/ChatContainer'
import SliderBar from '../components/SliderBar'
import {useCookies} from 'react-cookie'
import axios from 'axios'
import turnschuhe_icon from "../img/icon/turnschuhe_icon2.png"
import ruler_icon from "../img/icon/ruler-line.svg"
import bank_card_icon from "../img/icon/bank-card-fill.svg"
import location_icon from "../img/icon/map-pin-fill.svg"
import speak_icon from "../img/icon/speak-line.svg"
import {useNavigate} from "react-router-dom";
import { debounce } from 'lodash';
import config from '../config'
import { reverseSizeMap } from '../utils/sizeUtils';

const Dashboard  = () => {
    const [user, setUser] = useState(null)
    const [fitClothes, setFitClothes] = useState(null)
    const [lastDirection, setLastDirection] = useState(null)
    const [cookies, setCookie] = useCookies(['UserId','AuthToken','distance','max_price'])
    const [ownMatches, setOwnMatches] = useState(null)
    const [locations, setLocations] = useState(null);
    const [location, setLocation] = useState([]);

    let navigate = useNavigate()
    const userId = cookies.UserId
    const getLocations = async () => {

        try{
            const response = await axios.get(`${config.apiUrl}locations`)
            setLocations(response.data)
        }
        catch (error){
            console.log(error)
        }
    }
    const getUserLocation = async () => {

        try{
            await getLocations();
            const user = await getCurrentUser();
            if (user !== null && user !== undefined){
                const response = await axios.get(`${config.apiUrl}location`,
                {params: {plz:user.plz}})
                const myVar = response.data

                if ((typeof myVar === 'string' || myVar instanceof String)&&myVar.split(";").length === 2){
                    const coordinates = [parseFloat(myVar.split(";")[0]),parseFloat(myVar.split(";")[1])]
                    setLocation(coordinates)
                }
            }
            
        }
        catch (error){
            console.log(error)
        }
    }
    const getMatches = async () => {
        try {
            const response = await axios.get(`${config.apiUrl}matches`,{
                headers: {"token": localStorage.getItem("token")},
                params:{"userId": userId}
            })
            if (response.data === null || response.data === undefined){
                setOwnMatches([])
            }
            else{
                const matched_clothes_ids = response.data.map(match => match.matched_clothes_id);
                setOwnMatches(matched_clothes_ids)
            }
        }
        catch (error){
            console.log(error)
        }

    }


    const getCurrentUser = async () => {
        try {
            const response = await axios.get(`${config.apiUrl}user`, {
                headers: {"token": localStorage.getItem("token")},
                params: {userId}
            })
            setUser(response.data)
            return response.data
        } catch (error) {
            console.log(error)
        }
    }

    const getFittingClothes = async () => {        
        try {
            if (location.length < 2){ return}
            const response = await axios.get(`${config.apiUrl}clothing-cut-clothes`, {
                headers: {token: localStorage.getItem("token")},
                params: {clothing_cut: user?.clothing_cut,
                        user_id: userId,
                        shoe_size: user?.shoe_size,
                        top_size: user?.top_size,
                        trouser_size: user?.trouser_size,
                        "distance": cookies.distance, 
                        "location": location,
                        "max_price": cookies.max_price

                }
            })
            if (response.data === null || response.data === undefined){
                setFitClothes([])
            }
            else{
                setFitClothes(response.data)
            }
        } catch (error) {
            console.log(error)
        }
    }
    
    useEffect(()=>{
        getUserLocation();
        getMatches();
    },[cookies.distance, cookies.max_price]);

    useEffect(() => {
        if (!location || !user) return;
        getFittingClothes();
    }, [user, location]);

    useEffect(()=>{
        if (!cookies.distance && !cookies.max_price){
            setCookie("distance","5")
            setCookie("max_price","100")
        }
    },[])

    function truncateText(text, maxLength) {
        return text.length > maxLength
            ? text.slice(0, maxLength) + "..."
            : text;
        }

//https://api3.geo.admin.ch/rest/services/api/SearchServer?type=locations&searchText=8001
    const handleClick = () =>{
        navigate('/additem/0')
    }

    const updateOwnMatches = async (matchedClothesId, matchedOwnerId) => {
        try {
            await axios.post(`${config.apiUrl}match`, 
                {
                    "user_id":userId,
                    "matched_clothes_id":matchedClothesId,
                    "matched_owner_id":matchedOwnerId
                },
                {
                    headers: {"token": localStorage.getItem("token")},
                }
            )
            getMatches();

            
        } catch (err) {
            console.log(err)
        }

    }
    const handleSwipe = useCallback(
        debounce((direction, swipedClothesId, swipedClothesOwnerId) => {
            swiped(direction,swipedClothesId,swipedClothesOwnerId);
            setLastDirection(direction);
    },300),
    []
    );
    const swiped = async (direction, swipedClothesId, swipedClothesOwnerId) => {

        if (direction === 'right') {
            await updateOwnMatches(swipedClothesId, swipedClothesOwnerId);

        }
    };
    const outOfFrame = (name) => {
        console.log('Item left the screen!')
    }
    let filteredClothes = fitClothes?.filter(fitClothes => !ownMatches.includes(fitClothes._id))
    if (filteredClothes !== undefined && filteredClothes.length === 0){
        filteredClothes = undefined;
    }
    return (
        <>

            {user &&
                <div className="dashboard">

                    <ChatContainer user={user} own_matches={ownMatches}/>

                    <div className="swipe-container">
                        <div className="swipe-container-header">
                            <div onClick={handleClick} className="swipe-container-header-add-item-container">
                                <img src={turnschuhe_icon}/>
                            </div>
                        </div>
                        <div className="card-container">

                            {filteredClothes ? filteredClothes.map((clothes) =>
                                <TinderCard
                                    className="card-wrapper"
                                    key={clothes._id}
                                    preventSwipe={["up","down"]}
                                    onSwipe={(dir) => handleSwipe(dir, clothes._id, clothes.ownerId)}
                                    onCardLeftScreen={() => outOfFrame(clothes._id)}>
                                    <div
                                        style={{backgroundImage: "url(" + clothes.url + ")"}}
                                        className="card-content">
                                        <div className="card-description">
                                            <h4 className="specs">
                                                <img src={ruler_icon} alt ={"ruler icon"}/>{clothes.clothing_type === 'accessoire' || clothes.clothing_type === 'top' ? reverseSizeMap[clothes.clothing_cut][clothes.size]:clothes.size}
                                                <img src={location_icon} alt ={"location icon"}/>{clothes.plz}
                                                <img src={bank_card_icon} alt ={"bank card icon"}/>{clothes.price} CHF
                                            </h4>
                                            <span className="description"><img src={speak_icon} alt ={"speak icon"}/> {truncateText(clothes.description, 25)}</span>
                                        </div>
                                    </div>
                                </TinderCard>                             
                            ): <p className="no-clothing-found">Leider keine Kleidungsstücke in diesem Umkreis und dieser Preis-Limite gefunden. Vielleicht hast du morgen mehr Glück :)</p>}
                        </div>
                        <SliderBar />
                    </div>
                </div>}
        </>
    )
}
export default Dashboard
